import { useEffect, useRef, KeyboardEvent } from "react"
import { createPortal } from "react-dom"

import { KeyCodes } from "../../../enumerations"
import { Button } from "../../button"

import {
  SelectListPlacement,
  SelectListContainer,
  SelectListMobile,
  ChildrenContainer,
  SelectListContent,
  ButtonContainer,
  LabelContainer,
  FocusTrap,
} from "./styles"
import { SelectListProps } from "./types"

export const SelectList = ({
  children,
  label,
  textSubmit,
  isExpanded,
  isLoading,
  isMobile,
  hasActions,
  onRefList,
  onSubmit,
  onEscape,
  onWrap,
}: SelectListProps) => {
  const refListPlacement: any = useRef<HTMLDivElement | null>(null)
  const refListContainer: any = useRef<HTMLDivElement | null>(null)

  const handleButtonKeyDown = (event: KeyboardEvent) => {
    switch (event.which) {
      case KeyCodes.Escape:
        event.preventDefault()
        onEscape?.()
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (isMobile) {
      onRefList && refListPlacement && onRefList(refListPlacement)
    } else {
      onRefList && refListContainer && onRefList(refListContainer)
    }
  }, [isMobile])

  return isMobile ? (
    createPortal(
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      <SelectListMobile isExpanded={isExpanded} aria-hidden={!isExpanded}>
        <LabelContainer>{label}</LabelContainer>
        <SelectListContent>
          <FocusTrap onFocus={onWrap} tabIndex={isExpanded ? 0 : -1} aria-hidden />
          <ChildrenContainer>{children}</ChildrenContainer>
          <ButtonContainer>
            <Button fullWidth onClick={onSubmit} onKeyDown={handleButtonKeyDown}>
              {textSubmit}
            </Button>
            <FocusTrap onFocus={onWrap} tabIndex={isExpanded ? 0 : -1} aria-hidden />
          </ButtonContainer>
        </SelectListContent>
      </SelectListMobile>,
      document.body,
    )
  ) : (
    <SelectListPlacement ref={refListPlacement}>
      {/* eslint-disable-next-line jsx-a11y/role-supports-aria-props */}
      <SelectListContainer
        ref={refListContainer}
        isExpanded={isExpanded}
        isLoading={isLoading}
        hasActions={hasActions}
        aria-hidden={!isExpanded}
      >
        <FocusTrap onFocus={onWrap} tabIndex={isExpanded ? 0 : -1} aria-hidden />
        {children}
        <FocusTrap onFocus={onWrap} tabIndex={isExpanded ? 0 : -1} aria-hidden />
      </SelectListContainer>
    </SelectListPlacement>
  )
}
